module.exports = __webpack_public_path__ + "img/play-cards.ac5dbf3a.png";